import errorReporter from '@app/errorReporter';

angular.module('bb.util').factory('ErrorService', ErrorService);

/**
 * matches the link in the string, the format is the same as markdown link format:
 * [Text here](https://brokerbay.com/)
 *  */
const linkParser = rawText => {
  const linkMatchReg = /(.*)\[(.+)\]\((https?:\/\/.+)\).*/;
  const myMatch = rawText.match(linkMatchReg);
  // parse failed, no link in the rawText
  if (myMatch === null) return {};

  const [full, message, linkContent, link] = myMatch;
  return { message, linkContent, link };
};

ErrorService.$inject = ['ToastService'];
function ErrorService(ToastService) {
  function toastyHTTPErr(err) {
    const { status, data } = err;
    if (status >= 500) {
      const { message: rawMessage } = data;

      let { message, linkContent, link } = linkParser(rawMessage);
      if (message === undefined) message = rawMessage;

      ToastService.add({ message, type: 'danger', link, linkContent });
      errorReporter.error(err);
    } else if (status >= 400) {
      const rawMessage = typeof data === 'string' ? data : data.message;

      let { message, linkContent, link } = linkParser(rawMessage);
      if (message === undefined) message = rawMessage;

      ToastService.add({ message, type: 'warning', link, linkContent });
      errorReporter.error(err);
    } else {
      errorReporter.error(err);
    }
  }
  return {
    toastyHTTPErr,
  };
}
